import React, { useEffect } from 'react';
import '../PageCss/NewsEvent.css';
import '../PageCss/Job.css';
import SideNavNewsEvents from '../components/SideNavNewsEvents'
import { DetailsJob } from '../components/Job'
import { useAappContext } from '../context/AppContext';

const JobDetails = () => {
  const {getApiData, apiData,isLoadingApiData}=useAappContext()
  useEffect(()=>{
    getApiData('/jobrecruitment/')
  },[1])
  if(isLoadingApiData){
    <>loging data .............</>
  }
    return (
        <section id="newevent" className='section-m1 section-p1'>
            <div className="newevent">
              <div className="page-title">
              <div className="title-content-1"></div>
                <div className="title-content-2"> Job Details</div>
                <div className="title-content-3"></div>
                <div className="title-content-4"></div>
              </div>
              <div className="newevent-content">
              {
                apiData.map((curElem)=>{
                  return(
                    <DetailsJob key={curElem.id} {...curElem} />
                  )
                })
              }
               
          
                
             </div>
            </div>
            <SideNavNewsEvents/>
          
        </section>
      )
    }


export default JobDetails